@if (aliasList && aliasList.length) {
  <section class="page-list__section">
    <app-text-info-section
      [title]="title"
      [subtitle]="subtitle"
      [description]="description"
    ></app-text-info-section>
    <div class="page-list__container">
      @if (showList) {
        <ul class="page-list__list">
          @for (item of aliasList; track item) {
            <li class="page-list__list__item">
              @if (isArray(item.url) && authService.isAdmin()) {
                <i
                  class="far fa-copy"
                  (click)="utilityService.updateClipboard(item.url[0])"
                ></i>
              }
              @if (!isArray(item.url) && authService.isAdmin()) {
                <i
                  class="far fa-copy"
                  (click)="
                    utilityService.updateClipboard(
                      !item.url.includes('http') ? '/' + item.url : item.url
                    )
                  "
                ></i>
              }
              @if (isArray(item.url)) {
                <a
                  class="page-list__list__link"
                  [attr.style]="
                    linkColor ? 'color: ' + linkColor + ' !important;' : null
                  "
                  [routerLink]="[item.url[0]] | localize"
                  [queryParams]="item.url[1] ? item.url[1].queryParams : null"
                >
                  @if (item.fileName) {
                    <span>{{ item.fileName }}</span>
                  }
                  @if (!item.fileName) {
                    <span>{{ item.url }}</span>
                  }
                </a>
              }
              @if (!isArray(item.url) && !item.url.includes("http")) {
                <a
                  class="page-list__list__link"
                  [attr.style]="
                    linkColor ? 'color: ' + linkColor + ' !important;' : null
                  "
                  [routerLink]="['/' + item.url]"
                >
                  @if (item.fileName) {
                    <span>{{ item.fileName }}</span>
                  }
                  @if (!item.fileName) {
                    <span>{{ item.url }}</span>
                  }
                </a>
              }
              @if (!isArray(item.url)) {
                <a
                  class="page-list__list__link"
                  [attr.style]="
                    linkColor ? 'color: ' + linkColor + ' !important;' : null
                  "
                  [href]="item.url.includes('http') ? item.url : '/' + item.url"
                >
                  @if (item.fileName) {
                    <span>{{ item.fileName }}</span>
                  }
                  @if (!item.fileName) {
                    <span>{{ item.url }}</span>
                  }
                </a>
              }
            </li>
          }
          @if (authService.isAdmin()) {
            <div
              class="sitemap-section__toggle-collapse sitemap-section__toggle-collapse__page-list"
              onclick="toggleSitemapCollapse(this)"
            >
              Instorten <i class="fas fa-chevron-down"></i>
            </div>
          }
        </ul>
      }
    </div>
  </section>
}
